import * as React from "react";
import { FormattedMessage } from "react-intl";
import { Button } from "@/kit/ui/button";
import { Upload02Icon, Loading01Icon } from "@/icons";
import { ResponsiveModalContext } from "@/kit/helpers/responsive-modal";
import { ResponsiveModalFooter } from "@/kit/ui/responsive-modal";
import { useStateContext } from "./state";

export const Footer = () => {
  const {
    inferError,
    debugInferError,
    recordBatchesError,
    inferLoading,
    upload,
  } = useStateContext();
  const { setOpen } = React.useContext(ResponsiveModalContext);
  const canSubmit = !(
    inferError ||
    debugInferError ||
    recordBatchesError ||
    inferLoading
  );
  return (
    <ResponsiveModalFooter>
      <div className="flex items-center gap-2">
        <Button variant="secondary" onClick={() => setOpen?.(false)}>
          <FormattedMessage defaultMessage="Cancel" />
        </Button>
        <Button
          variant="primary"
          disabled={!canSubmit}
          onClick={() => upload(() => setOpen?.(false))}
        >
          {inferLoading ? (
            <Loading01Icon className="animate-spin" />
          ) : (
            <Upload02Icon />
          )}
          <FormattedMessage defaultMessage="Upload Dataset" />
        </Button>
      </div>
    </ResponsiveModalFooter>
  );
};
